import { 
    gql, 
    useMutation, 
    ApolloError 
} from "@apollo/client";
import { UpdateCategoryMutationMutation, UpdateCategoryMutationMutationVariables } from "../../../../../schemaTypes";

export const updateCategoryMutation = gql`
  mutation UpdateCategoryMutation(
    $categoryId: String!
    $input: UpdateCategoryInput!
  ) {
    updateCategory(
      categoryId: $categoryId,
      input: $input
    ) {
      errors {
        path
        message
      }
      message
      imgSrcUrl
    }
  }
`;

interface Props {
  onMessage?: (message: string) => void;
  children: (
    data: {
      submit: (
        values: UpdateCategoryMutationMutationVariables & { imgSrc?: File }
      ) => Promise<{
        errors: ({ path: string; message: string } | null)[] | null;
        message?: string;
        imgSrcUrl?: string;
      }>;
      loading: boolean;
      error?: ApolloError;
    }
  ) => React.ReactElement | null;
}

function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export const UpdateCategoryController: React.FC<Props> = ({ children, onMessage }) => {
  const [updateCategory, { loading, error }] = useMutation<
    UpdateCategoryMutationMutation,
    UpdateCategoryMutationMutationVariables
  >(updateCategoryMutation);

  const submit = async (
    values: UpdateCategoryMutationMutationVariables & { imgSrc?: File }
  ) => {
    const { imgSrc, ...rest } = values;
    let imgSrcUrl = rest.input.imgSrc;
    if (imgSrc) {
      imgSrcUrl = await fileToBase64(imgSrc);
    }
    const { data } = await updateCategory({
      variables: {
        categoryId: rest.categoryId,
        input: {
          ...rest.input,
          imgSrc: imgSrcUrl
        },
      },
    });

    const errors = data?.updateCategory?.errors ?? null;
    const message = data?.updateCategory?.message ?? undefined;
    const imgSrcUrlResp = data?.updateCategory?.imgSrcUrl ?? undefined;

    if (message && onMessage) {
      onMessage(message);
    }

    return {
      errors,
      imgSrcUrl: imgSrcUrlResp,
      message,
    };
  };

  return children({ submit, loading, error });
};